import type { ComponentType } from 'react';

import {
  KnownUnitOverviewColumn,
  type UnitOverviewRow,
} from '@/warranty-v3/entities/overview';

// Cell components
import { AgeInYearsCell } from './cells/age-in-years-cell';
import { AvgContainerTagCell } from './cells/avg-container-tag-cell';
import { AvgPcsTagCell } from './cells/avg-pcs-tag-cell';
import { ComplianceStatusCell } from './cells/compliance-status-cell';
import { CoverageStatusCell } from './cells/coverage-status-cell';
import { CyclesTotalCell } from './cells/cycles-total-cell';
import { FrontendIdCell } from './cells/frontend-id-cell';
import { GuaranteedSOHCell } from './cells/guaranteed-soh-cell';
import { SOHCell } from './cells/soh-cell';
import { SuggestedActionCell } from './cells/suggested-action-cell';
import { ThroughputTotalCell } from './cells/throughput-total-cell';
// Header components
import { AgeInYearsHeader } from './headers/age-in-years-header';
import { AvgContainerTagHeader } from './headers/avg-container-tag-header';
import { AvgPcsTagHeader } from './headers/avg-pcs-tag-header';
import { ComplianceStatusHeader } from './headers/compliance-status-header';
import { CoverageStatusHeader } from './headers/coverage-status-header';
import { CyclesTotalHeader } from './headers/cycles-total-header';
import { FrontendIdHeader } from './headers/frontend-id-header';
import { GuaranteedSOHHeader } from './headers/guaranteed-soh-header';
import { SOHHeader } from './headers/soh-header';
import { SuggestedActionHeader } from './headers/suggested-action-header';
import { ThroughputTotalHeader } from './headers/throughput-total-header';

type ColumnConfig = {
  header: ComponentType;
  cell: ComponentType<{ row: UnitOverviewRow }>;
};

export const columnsRegistry: Record<
  KnownUnitOverviewColumn | (string & {}),
  ColumnConfig | undefined
> = {
  [KnownUnitOverviewColumn.FRONTEND_ID]: {
    header: FrontendIdHeader,
    cell: FrontendIdCell,
  },
  [KnownUnitOverviewColumn.COVERAGE_STATUS]: {
    header: CoverageStatusHeader,
    cell: CoverageStatusCell,
  },
  [KnownUnitOverviewColumn.COMPLIANCE_STATUS]: {
    header: ComplianceStatusHeader,
    cell: ComplianceStatusCell,
  },
  [KnownUnitOverviewColumn.SUGGESTED_ACTION]: {
    header: SuggestedActionHeader,
    cell: SuggestedActionCell,
  },
  [KnownUnitOverviewColumn.AGE_IN_YEARS]: {
    header: AgeInYearsHeader,
    cell: AgeInYearsCell,
  },
  [KnownUnitOverviewColumn.CYCLES_TOTAL]: {
    header: CyclesTotalHeader,
    cell: CyclesTotalCell,
  },
  [KnownUnitOverviewColumn.THROUGHPUT_TOTAL]: {
    header: ThroughputTotalHeader,
    cell: ThroughputTotalCell,
  },
  [KnownUnitOverviewColumn.GUARANTEED_SOH]: {
    header: GuaranteedSOHHeader,
    cell: GuaranteedSOHCell,
  },
  [KnownUnitOverviewColumn.SOH]: {
    header: SOHHeader,
    cell: SOHCell,
  },
  [KnownUnitOverviewColumn.AVG_CONTAINER_TAG]: {
    header: AvgContainerTagHeader,
    cell: AvgContainerTagCell,
  },
  [KnownUnitOverviewColumn.AVG_PCS_TAG]: {
    header: AvgPcsTagHeader,
    cell: AvgPcsTagCell,
  },
};
